module.exports = __webpack_public_path__ + "static/media/documents-tutorial.5a865a07.png";